import { types } from 'mobx-state-tree';

export const ResizableImage = types
  .model('ResizableImage', {
    url: types.maybeNull(types.string),
    path: types.maybeNull(types.identifier),
    width: types.maybeNull(types.number),
    height: types.maybeNull(types.number),
    name: types.maybeNull(types.string),
    uploadedDate: types.maybeNull(types.string),
    size: types.maybeNull(types.number),
  })
  .actions((self) => ({
    setDimension({ width, height }) {
      self.width = width;
      self.height = height;
    },
  }));

export const Spot = types
  .model('Spot', {
    text: types.string,
    id: types.identifier,
    x: types.number,
    y: types.number,
  })
  .actions((self) => ({
    setCoordinate(x: number, y: number) {
      self.x = x;
      self.y = y;
    },
    setText(text: string | number) {
      self.text = `${text}`;
    },
  }));

export const QuestionWithSpots = types.model({
  image: types.maybeNull(ResizableImage),
  userAnswers: types.array(types.maybeNull(types.number)),
});

export const QuestionGapFillWithSpots = types.model({
  image: types.maybeNull(ResizableImage),
  userAnswers: types.array(types.maybeNull(types.string)),
});
